import React from "react";
import { Plus, Minus } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function FAQ() {
  const { content } = useSiteContent();
  const { faqs } = content;
  const [openIdx, setOpenIdx] = React.useState(0);

  return (
    <main>
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <span className="kicker">FAQ</span>
          <h1 className="hero-heading text-white text-5xl md:text-6xl mt-5">Clear answers to common questions.</h1>
          <p className="text-slate-300 text-lg max-w-3xl mx-auto mt-6 leading-relaxed">Starting care at home is a big step. We want you to feel informed, comfortable, and ready for whatever comes next.</p>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 space-y-4">
          {faqs.map((f, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div key={idx} className={`card-soft overflow-hidden transition ${isOpen ? "border-[#c7e34a]/40" : ""}`}>
                <button onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  className="w-full flex items-center justify-between p-6 text-left gap-6">
                  <span className="font-serif-display text-white text-xl md:text-2xl">{f.q}</span>
                  <span className="w-10 h-10 shrink-0 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#c7e34a]">
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-500 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-slate-300 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
